interface SummaryStats {
    location: string,
    total: number,
    median: number,
    average: number,
}

interface TherapistPerRxSummaryStats {
  location: string;
  // sampleSize: number; // number of Rxs in the location
  median: number;     // median therapists per Rx
  average: number;    // average therapists per Rx
  min: number;        // minimum therapists in a Rx
  max: number;        // maximum therapists in a Rx
}

interface RxLifespanSummaryStats {
  location: string;
  delta: string;
  median: number;
  average: number;
  min: number;
  max: number;
}

interface ColumnNameConfig<T> {
  header: string;
  field: keyof T; 
  align?: "left" | "right" | "center";
  format?: (val: T[keyof T], row?: T) => string | number;
};

export const summaryStatsTableConfigs = {
  counts: {
    columns: [
      { header: 'Gesamt', field: 'total', align: 'right', format: (val: number) => new Intl.NumberFormat("de-DE").format(val) },
      { header: 'Median', field: 'median', align: 'right', format: (val: number) => new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val) },
      { header: 'Durchschnitt', field: 'average', align: 'right', format: (val: number) => new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val) },
    ] as ColumnNameConfig<SummaryStats>[],
  },

  values: {
    columns: [
      { header: 'Gesamt', field: 'total', align: 'right', format: (val:number) => new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2}).format(val) },
      { header: 'Median', field: 'median', align: 'right', format: (val:number) => new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2}).format(val) },
      { header: 'Durchschnitt', field: 'average', align: 'right', format: (val:number) => new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2}).format(val) },
    ] as ColumnNameConfig<SummaryStats>[],
  },

  therapistsPerRx: {
    columns: [
      // { header: 'Rxs', field: 'sampleSize', align: 'right', format: (val: number) => new Intl.NumberFormat("de-DE").format(val) },
      { header: 'Median', field: 'median', align: 'right', format: (val: number) => new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val) },
      { header: 'Durchschnitt', field: 'average', align: 'right', format: (val: number) => new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val) },
      { 
        header: 'Min-Max', 
        field: 'min', 
        align: 'right',
        format: (val: number, row?: TherapistPerRxSummaryStats) => {
          if (row) {
            const minFormatted = new Intl.NumberFormat("de-DE").format(row.min);
            const maxFormatted = new Intl.NumberFormat("de-DE").format(row.max);
            return `${minFormatted}-${maxFormatted}`;
          }
          return new Intl.NumberFormat("de-DE").format(val);
        }
      },
    ] as ColumnNameConfig<TherapistPerRxSummaryStats>[],
  },

  rxLifespan: {
    columns: [
      { header: 'Bearbeitungsdauer', field: 'delta', align: 'left', format: (val: string) => val },
      { header: 'Median', field: 'median', align: 'right', format: (val: number) => new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val) },
      { header: 'Durchschnitt', field: 'average', align: 'right', format: (val: number) => new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val)},
      { 
        header: 'Min-Max', 
        field: 'min', 
        align: 'right',
        format: (val: number, row?: RxLifespanSummaryStats) => {
          if (row) {
            const minFormatted = new Intl.NumberFormat("de-DE").format(row.min);
            const maxFormatted = new Intl.NumberFormat("de-DE").format(row.max);
            return `${minFormatted}-${maxFormatted}`;
          }
          return new Intl.NumberFormat("de-DE").format(val);
        }
      },
    ] as ColumnNameConfig<RxLifespanSummaryStats>[],
  }
}